import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { LockerBasicRequest } from "./LockerBasicRequest";
import { LockerUpdateRequest } from "./LockerUpdateRequest";
import { LockerInsertSingleRequest } from "./LockerInsertSingleRequest";
import { LockerInsertMultipleRequest } from "./LockerInsertMultipleRequest";
import { LockerBulkAssignRequest } from "./LockerBulkAssignRequest";
import { LockerExistsRequest } from "./LockerExistsRequest";
import { StringIntRequest } from "../../guardian-type-setup/shared/StringIntRequest";
import { LockerImportPreviewRequest } from "./LockerImportPreviewRequest";
import { StudentImportPreviewRequest } from "./StudentImportPreviewRequest";
import { LockerImportRequest } from "./LockerImportRequest";

@Injectable()
export class DataService_Locker {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	LockerTableSelectList(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/LockerTableSelectList?SchoolID=" + SchoolID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DeleteLockers(parms: LockerBasicRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/DeleteLockers";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UnassignLockers(parms: LockerBasicRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/UnassignLockers";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LockerUpdate(parms: LockerUpdateRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/LockerUpdate";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LockerExists(parms: LockerExistsRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/LockerExists";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LockerInsertSingle(parms: LockerInsertSingleRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/LockerInsertSingle";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LockerPaddingOptionSelectList() {
		var postResult$ = new Subject();
		var url = "SchoolSetup/LockerPaddingOptionSelectList?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LockerInsertMultiple(parms: LockerInsertMultipleRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/LockerInsertMultiple";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LockerAssignStudentsSelectList(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/LockerAssignStudentsSelectList?SchoolID=" + SchoolID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LockerBulkAssign(parms: LockerBulkAssignRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/LockerBulkAssign";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LockerHistoryInfoSelectList(LockerID) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/LockerHistoryInfoSelectList?LockerID=" + LockerID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LockerPersonUpdateComments(parms: StringIntRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/LockerPersonUpdateComments";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LockerFormatSelectList() {
		var postResult$ = new Subject();
		var url = "SchoolSetup/LockerFormatSelectList?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LockerExport(SchoolID, AssignableOption, ShowStudentID, FormatOption) {
		var postResult$ = new Subject();
		var url =
			"SchoolSetup/LockerExport?SchoolID=" +
			SchoolID +
			"&AssignableOption=" +
			AssignableOption +
			"&ShowStudentID=" +
			ShowStudentID +
			"&FormatOption=" +
			FormatOption;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadImportPreviewData(parms: LockerImportPreviewRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/LoadImportPreviewData";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadImportPreviewAll(parms: StudentImportPreviewRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/LoadImportPreviewAll";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LockerFinishImport(parms: LockerImportRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/LockerFinishImport";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
